import vue from '@/main'

import store from "@/store/store.js"
import jwt from "../../http/requests/auth/jwt/index.js"

import router from '@/router'

export default {

  // JWT
  loginJWT: function ({commit}, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password, payload.remember)
        .then(response => {

          // If there's user data in response
          if (response.data.data.logIn.token) {
            // Update user details
            store.commit('UPDATE_USER_INFO', response.data.data.logIn.user)

            // Set bearer token in axios
            commit("SET_BEARER", response.data.data.logIn.token)

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/' + router.currentRoute.params.tenant + '/')

            vue.$vs.notify({
              color: 'success',
              title: 'Logado com sucesso!',
              text: 'Você entrou na plataforma com sucesso!'
            })

            resolve(response)
          } else {
            reject({message: "Wrong Email or Password"})
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  refreshAccessToken({ commit }) {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => {
        commit("SET_BEARER", response.data.data.refreshToken.token)
        resolve(response.data.data.refreshToken.token)
      })
    })
  },
  disconnected() {
    return new Promise((resolve) => {
        jwt.disconnected().then(response => {
            resolve(response.data.data.disconnected)
        })
    })
  }
}
